import {useHistory} from "react-router-dom";
import React, {memo, useCallback} from "react";
import {makeStyles} from "@material-ui/core/styles";
import {userName} from "../../../helpers";
import DropDownContent from "./DropDownContent";

const useStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        position: 'relative'
    },
    label: {
        cursor: "pointer"
    }
})

const HeadMenuDropdown = ({user, openDropdown, setOpenDropdown}) => {

    const classes = useStyles()
    const label = user ? userName(user) : 'Unauthorized'

    const toggle = useCallback(() => {
        setOpenDropdown(o => !o)
    }, [])

    return (
        <li className={classes.root}>
            <a onClick={toggle} className={classes.label}>{label}</a>
            <DropDownContent open={openDropdown} setOpen={setOpenDropdown}/>
        </li>)
};

export default memo(HeadMenuDropdown)